import { fetchUserAttributes, fetchAuthSession } from 'aws-amplify/auth';
import { getUrl, uploadData, remove } from 'aws-amplify/storage';
import axios from 'axios';
import { requestCognitoClient } from '../Networking/clients';


export const availCategories = [
    { label: "Billers", number: "1", background: "#EE8493" },
    { label: "Billing Tools", number: "2", background: "#FEFDE5" },
    { label: "Consultants", number: "3", background: "#A3AAF9" },
    { label: "CRMs", number: "4", background: "#F2BCC2" },
    { label: "Devices", number: "5", background: "#B9DBCA" },
    { label: "Patient Engagement", number: "7", background: "#F7D5B8" },
    { label: "Remote Patient Monitoring", number: "8", background: "#D9F7E7" },
    { label: "Supplement Dispensary", number: "9", background: "#C0BBDD" },
    { label: "Transcription", number: "10", background: "#FBE6D1" },
    { label: "Tech Led Innovations", number: "11", background: "#F7D5B8" },
    { label: "Venture Capital / Incubator", number: "12", background: "#82C0E6" },
    { label: "Workflow & Productivity", number: "13", background: "#DBD7F2" },
    { label: "Marketing", number: "14", background: "#DAD8B4" },
    { label: "Developers", number: "15", background: "#C1E5FC" },
    { label: "Health Information Exchange", number: "16", background: "#F3F1E8" },
];

export const getUserAttributes = async () => {
    try {
        const userAttributes = await fetchUserAttributes(['custom:userType']);
        return userAttributes;
    } catch (error) {
        console.error('ERR-01: Error getting user attributes', error);
    }
};

export const getUserEmail = async () => {
    try {
        const attributes = await getUserAttributes();
        return attributes.email;
    } catch (error) {
        console.error('ERR-02: Error getting user email', error);
    }
};

export const getVendorId = async () => {
    try {
        const attributes = await getUserAttributes();
        if (attributes['custom:vendorId'] == undefined) {
            await onBoardVendorId();
            return fetchUserAttributes(['custom:vendorId']);
        }
        return attributes['custom:vendorId'];
    } catch (error) {
        console.error('ERR-03: Error getting vendor ID', error);
        return null;
    }
};

export const onBoardVendorId = async () => {
    //The following code gets the vendor information from the database and updates it in the cognito pool
    const apiEndpoint = "https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/update-vendor-information"
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': idToken
    };
    try {
        await axios.post(apiEndpoint, {}, { headers: headers });
    } catch (error) {
    }
};

export const createVendor = async (payload) => {
    const apiEndpoint = "https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/vendor-signup";
    const headers = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await axios.post(apiEndpoint, payload, { headers: headers });
        return true;
    } catch (error) {
        return null;
    }
};

export const getVendorProfile = async (showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: `
            query MyQuery {
                vendors(filter: {}) {
                    address
                    has_api_interest
                    approval_status
                    company_name
                    number_of_employees
                    year_founded
                    contact_phone_number
                    service_description
                    serve_plan
                    service_specialties
                    vendor_bio
                    website
                    revenue
                    title
                    contact_name
                    contact_email
                    is_active
                }   
            }
            `
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const vendorData = response.data?.data?.vendors?.[0];
        return vendorData;
    } catch (error) {
        console.error('ERR-05: Error getting vendor profile.', error);
        showToast && showToast('Error ERR-05', 'Unable to get vendor profile.', 'error');
        return null;
    }
};

export const updateVendorProfile = async (updateVendorProfile, showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: `
            mutation MyMutation {
                updateVendor(input: {
                    company_name: "${updateVendorProfile.company_name}",
                    vendor_bio: "${updateVendorProfile.vendor_bio}",
                    address: "${updateVendorProfile.address}",
                    vendor_bio: "${updateVendorProfile.vendor_bio}",
                    website: "${updateVendorProfile.website}",
                    year_founded: "${updateVendorProfile.year_founded}",
                    number_of_employees: "${updateVendorProfile.number_of_employees}", 
                    revenue: "${updateVendorProfile.revenue}",
                    service_specialties: "${updateVendorProfile.service_specialties}",
                    service_description: "${updateVendorProfile.service_description}",
                    has_api_interest: ${updateVendorProfile.has_api_interest},
                    title: "${updateVendorProfile.title}",
                    contact_name: "${updateVendorProfile.contact_name}",
                    contact_phone_number: "${updateVendorProfile.contact_phone_number}",
                    serve_plan: "${updateVendorProfile.serve_plan.replace(/[\r\n]+/gm, " ")}"
                }) {
                    id
                }
            }
            `
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const updatedVendorData = response.data?.data?.updateVendor;
        showToast && showToast('Success', 'Vendor profile updated successfully!', 'success');
        return updatedVendorData;
    } catch (error) {
        console.error('ERR-06: Error updating vendor profile.', error);
        showToast && showToast('Error ERR-06', 'Unable to update vendor profile.', 'error');
        return null;
    }
};

export const getVendorListings = async (showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: `
            query MyQuery {
                products(filter: {}) {
                    description
                    name
                    thumbnail
                    is_published
                    id
                    created_at
                    categories {
                        id
                    }
                }
            }
            `
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const listings = response.data?.data?.products;
        return listings;
    } catch (error) {
        console.error('ERR-07: Error getting vendor listings.', error);
        showToast && showToast('Error ERR-07', 'Unable to get vendor listings.', 'error');
        return null;
    }
};

export const getVendorOrders = async (showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: `
            query MyQuery {
                orders(filter: {}) {
                    id
                    status
                    created_at
                    updated_at
                    product {
                        id
                        name
                    }
                    practice_user_email
                    practice_name
                }
            }
            `
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const orders = response.data?.data?.orders;
        return orders;
    } catch (error) {
        console.error('ERR-08: Error getting vendor orders.', error);
        showToast && showToast('Error ERR-08', 'Unable to get vendor orders.', 'error');
        return null;
    }
};

export const getOrderMessages = async (orderId, showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: `
            query MyQuery {
                orderMessages(filter: { order_id: "${orderId}" }) {
                    id
                    attachment
                    message
                    created_at
                    order_id
                    recipient
                    sender
                    updated_at
                }
            }
            `
        });


        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const messages = response.data?.data?.orderMessages;
        return messages;
    } catch (error) {
        console.error('ERR-10: Error getting vendor messages.', error);
        showToast && showToast('Error ERR-10', 'Unable to get vendor messages.', 'error');
        return null;
    }
};

export const sendOrderMessages = async (orderId, message, attachmentUrl, showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    const createMessageMutation = `
    mutation CreateOrderMessage($input: OrderMessageInput!) {
      createOrderMessage(input: $input) {
        id
        attachment
        message
        created_at
        order_id
        recipient
        sender
        updated_at
      }
    }
  `;

    const messageInput = {
        order_id: orderId,
        message: message,
        attachment: attachmentUrl,
    };

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: createMessageMutation,
            variables: { input: messageInput },
        });


        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const sentMessage = response.data?.data?.createOrderMessage;
        showToast && showToast('Success', 'Message sent successfully!', 'success');
        return sentMessage;

    } catch (error) {
        console.error('ERR-11: Error sending vendor messages.', error);
        showToast && showToast('Error ERR-11', 'Unable to send vendor messages.', 'error');
        return null;
    }
};

export const setOrderStatus = async (orderId, status, showToast, showSuccessToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const updateStatusMutation = `
    mutation UpdateOrderStatus($input: UpdateOrderInput!) {
      updateOrderStatus(input: $input) {
        id
        status
        created_at
        updated_at
        product {
          id
          name
        }
        practice_user_email
        practice_name
      }
    }
    `;

    const statusInput = {
        id: orderId,
        status: status,
    };

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: updateStatusMutation,
            variables: { input: statusInput },
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const updatedOrderStatus = response.data?.data?.updateOrderStatus;
        showToast && showToast('Success', 'Order status updated successfully!', 'success');
        return updatedOrderStatus;

    } catch (error) {
        console.error('ERR-12: Error updating order status.', error);
        showToast && showToast('Error ERR-12', 'Error updating order status', 'error');
        return null;
    }
};


export const handleSaveDataToS3 = async (img, showToast) => {

    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data type prefix
                reader.onerror = (error) => reject(error);
            });

        const base64Image = await toBase64(img);

        // Call the API with the Base64 image
        const response = await axios.post(
            'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/vendor-image-upload',
            { image: base64Image },
            {
                headers: {
                    'Authorization': `${idToken}`
                }
            });

        // Extract the image URL from the response
        if (response.status === 200) {
            const { image_url } = response.data;
            return image_url;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error uploading image to S3:', error);
        return null;
    }
};


export const removeDatainS3 = async (resourceUrl, showToast) => {
    try {
        // Extract the path from the URL (removing the domain and query parameters)
        let s3Key = resourceUrl.split('/').slice(3).join('/'); // Extract the key after the domain
        s3Key = decodeURIComponent(s3Key); // Decode any URL-encoded characters        
        // Perform the remove operation using the decoded key
        const result = await remove({
            path: () => s3Key,
        }).result;
        return result;
    } catch (error) {
        console.error('ERR-14: Error removing data from S3.', error);
        showToast('Error ERR-14', 'Error removing data from S3', 'error');
        return null;
    }
};

export async function createNewProduct(newProduct, showToast) {

    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    const createProductMutation = `
    mutation createProduct($input: CreateProductInput!) {
        createProduct(input: $input) {
            id 
            banner
            website
            description
            thumbnail
            contact_email
            is_published
            images
            name
            pricing
            has_free_version
            has_free_trial
            categories {
                id
            }
        }
    }
    `;

    const productInput = {
        category_ids: newProduct.categories, // Ensure this is an array
        name: newProduct.productName,
        website: newProduct.websiteUrl,
        description: newProduct.productDescription,
        features: newProduct.productFeatures,
        thumbnail: newProduct.logoUrl,
        images: newProduct.images,
        videos: newProduct.videos,
        banner: newProduct.bannerUrl,
        contact_email: newProduct.email,
        twitter: newProduct.X,
        facebook: newProduct.Facebook,
        instagram: newProduct.Instagram,
        linkedin: newProduct.Linkedin,
        pricing: newProduct.pricingUrl,
        has_free_version: newProduct.freeVersion === 'true',
        has_free_trial: newProduct.freeTrial === 'true',
    };

    try {
        // Send the create product mutation
        const response = await requestCognitoClient(idToken).post('', {
            query: createProductMutation,
            variables: { input: productInput },
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const createdProduct = response.data?.data?.createProduct;
        showToast && showToast('Success', 'Product created successfully!', 'success');
        return createdProduct;

    } catch (error) {
        console.error('ERR-15: Error creating a new product.', error);
        showToast && showToast('Error ERR-15', 'Error creating a new product', 'error');
        return null;
    }
};

export async function updateProductListing(newProduct, productID, showToast, showSuccessToast) {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const updateProductMutation = `
    mutation MyMutation(
        $name: String!,
        $website: String!,
        $description: String!,
        $features: String!,
        $thumbnail: String!,
        $images: String!,
        $videos: String!,
        $banner: String!,
        $contact_email: String!,
        $twitter: String!,
        $facebook: String!,
        $instagram: String!,
        $linkedin: String!,
        $pricing: String!,
        $has_free_version: Boolean!,
        $has_free_trial: Boolean!,
        $category_ids: [ID!],
        $id: ID!
    ) {
        updateProduct(input: {
            name: $name,
            website: $website,
            description: $description,
            features: $features,
            thumbnail: $thumbnail,
            images: $images,
            videos: $videos,
            banner: $banner,
            contact_email: $contact_email,
            twitter: $twitter,
            facebook: $facebook,
            instagram: $instagram,
            linkedin: $linkedin,
            pricing: $pricing,
            has_free_version: $has_free_version,
            has_free_trial: $has_free_trial,
            category_ids: $category_ids,
            id: $id
        }) {
            description
            features
            name
            thumbnail
            is_published
            id
            created_at
        }
    }
    `;

    const productInput = {
        name: newProduct.productName,
        website: newProduct.websiteUrl,
        description: newProduct.productDescription,
        features: newProduct.productFeatures,
        thumbnail: newProduct.logoUrl,
        images: newProduct.images,
        videos: newProduct.videos,
        banner: newProduct.bannerUrl,
        contact_email: newProduct.email,
        twitter: newProduct.X,
        facebook: newProduct.Facebook,
        instagram: newProduct.Instagram,
        linkedin: newProduct.Linkedin,
        pricing: newProduct.pricingUrl,
        has_free_version: newProduct.freeVersion === 'true',
        has_free_trial: newProduct.freeTrial === 'true',
        category_ids: newProduct.categories,
        id: productID
    };

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: updateProductMutation,
            variables: productInput,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        const updatedProduct = response.data?.data?.updateProduct;
        showToast && showToast('Success', 'Product updated successfully!', 'success');
        return updatedProduct;

    } catch (error) {
        console.error('ERR-16: Error updating product details.', error);
        showToast && showToast('Error ERR-16', 'Error updating product details', 'error');
        return null;
    }
};

export async function publishListing(productID, showToast) {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const publishProductMutation = `
    mutation MyMutation {
        updateProduct(input: {
            id: "${productID}",
            is_published: true
        }) {
            description
            name
            thumbnail
            is_published
            categories {
                id
            }
            id
            created_at
        }
    }
    `;

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: publishProductMutation,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        showToast && showToast('Success', 'Product published successfully!', 'success');
        return response.data?.data?.updateProduct;
    } catch (error) {
        console.error('ERR-17: Error publishing product.', error);
        showToast && showToast('Error ERR-17', 'Error publishing product', 'error');
        return null;
    }
};

export async function unpublishListing(productID, showToast) {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const unpublishProductMutation = `
    mutation MyMutation {
        updateProduct(input: {
            id: "${productID}",
            is_published: false
        }) {
            description
            name
            thumbnail
            is_published
            id
            created_at
        }
    }
    `;

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: unpublishProductMutation,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        showToast && showToast('Success', 'Product un-published successfully!', 'success');
        return response.data?.data?.updateProduct;

    } catch (error) {
        console.error('ERR-18: Error un-publishing product.', error);
        showToast && showToast('Error ERR-18', 'Error un-publishing product', 'error');
        return null;
    }
};


export const getProductListing = async (productID, showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const getProductQuery = `
    query MyQuery {
        products(filter: {id: "${productID}"}) {
            name
            description
            features
            thumbnail
            website
            images
            videos
            banner
            contact_email
            linkedin
            twitter
            facebook
            instagram
            pricing
            has_free_version
            has_free_trial
            id
            is_published
            categories {
                id
            }
        }
    }
    `;

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: getProductQuery,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data?.data?.products[0];
    } catch (error) {
        console.error('ERR-19: Error retrieving product.', error);
        showToast && showToast('Error ERR-19', 'Error retrieving product', 'error');
        return null;
    }
};

export const getReviewsByVendor = async (showToast) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();
    const query = `
        query {
            reviews {
                id
                practice_user_name
                practice_user_email
                rating
                comment
                created_at
                vendor_response
                product {
                    id
                    name
                }
            }
        }
    `;

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: query,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data?.data?.reviews;

    } catch (error) {
        console.error('ERR-20: Error fetching product reviews.', error);
        showToast && showToast('Error ERR-20', 'Error fetching product reviews', 'error');
        return null;
    }
}

export const respondToReview = async (reviewId, vendorResponse, showToast) => {

    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    const respondToReviewMutation = `
        mutation {
            updateReviewVendor(input: {
                id: "${reviewId}",
                vendor_response: "${vendorResponse}",                  
            }) {
                id
            }
        }
    `;

    try {
        const response = await requestCognitoClient(idToken).post('', {
            query: respondToReviewMutation,
        });

        if (response.data?.errors) {
            console.error('GraphQL Error:', response.data.errors);
            return null;
        }

        return response.data?.data?.updateReviewVendor.id;

    } catch (error) {
        console.error('ERR-21: Error responding to product reviews.', error);
        showToast && showToast('Error ERR-21', 'Error responding to product reviews', 'error');
        return null;
    }
}


export const getVendorNotifications = async () => {

    const vendorId = await getVendorId();
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await axios.get(
            'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/vendor-notification',

            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken,
                },
            }
        );
        return response.data.notifications;
    }
    catch (error) {
        console.error('ERR-22: Error fetching vendor notifications.', error);
        return null;
    }
}

export const changeVendorEmailInitiate = async (email) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await axios.post(
            'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/update-email/initiate',
            {
                newEmail: email
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken,
                },
            }
        );
        return response;
    }
    catch (error) {
        return null;
    }
}

export const changeVendorEmailVerify = async (code) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens.idToken.toString();

    try {
        const response = await axios.post(
            'https://xjmn0g1tf5.execute-api.us-east-1.amazonaws.com/production/update-email/verify',
            {
                otp: code
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': idToken,
                },
            }
        );
        return response;
    }
    catch (error) {
        return null;
    }
}